export const isBrowserInternetExplorer = () => {
  const { userAgent } = window.navigator;
  return userAgent.indexOf("Trident/") > 0;
};
